import { useState, useEffect } from 'react';
import axios, { endpoints } from 'src/utils/axios';
import { fParams, ParamsType } from 'src/utils/format-params';
import { BranchType } from 'src/type/branch';
import { Pagination } from 'src/type/utils';
import { omit } from 'lodash';
import { useBoolean } from './use-boolean';

export default function useBranchOptions() {
  const loading = useBoolean(true);
  const [options, setOptions] = useState<{ label: string; value: string }[]>([]);

  useEffect(() => {
    (async () => {
      try {
        let branches = Array<BranchType>();
        const firstChunk = await getBranches();

        if (!firstChunk.results.length) {
          throw new Error('No branches found');
        }

        branches = [...firstChunk.results];
        const paginateInfo = omit(firstChunk, 'results');

        for (let i = 1; i <= paginateInfo.totalPages; i += 1) {
          // eslint-disable-next-line no-await-in-loop
          const chunk = await getBranches({ lastDocId: branches[branches.length - 1].id });
          branches = [...branches, ...chunk.results];
        }

        const opt = branches?.map((branch) => ({
          label: branch.name,
          value: branch.id,
        }));

        setOptions(opt);
      } catch (error) {
        setOptions([]);
      } finally {
        loading.onFalse();
      }
    })();
  }, []);

  const getBranches = async (params?: ParamsType) => {
    const _params = {
      limit: 30,
      ...params,
    };

    const { data } = await axios.get<Pagination<BranchType>>(endpoints.branch.get, {
      params: fParams(_params),
    });
    return data;
  };

  return { branchOptions: options, isBranchOptionsLoading: loading.value };
}
